module.exports = __webpack_public_path__ + "img/load-template-light.844c1828.svg";